import {
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined,
  LoadingOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Button, Col, Form, Table, Tooltip, Typography } from "antd";
import { Flex } from "antd";
import { Upload } from "antd";
import { Row } from "antd";
import React, { FC } from "react";
import { IDocumentFields } from "../../../interfaces/ICase";

type EnhancementCghsDocumentProps = {
  documentTypes: any;
  handleFileChange: any;
  uploadedDocumentUrl: Array<IDocumentFields>;
  handleDownloadDocument: any;
  isDownloadingDocument?: boolean;
  downloadingDocumentUrl?: string;
  handleOpen: any;
  handleSetDocumentUrl: any;
  handleDeleteList: any;
  setDocumentName: any;
  handleDeficiencyModal: any;
  deficiencyQuestions: any;
  form: any;
  handleSubmit: any;
  activeStep: string;
  onPrevious: () => void;
};

const EnhancementCghsDocument: FC<EnhancementCghsDocumentProps> = (props) => {
  const { Text } = Typography;
  return (
    <>
      <Form form={props?.form} className="enhancement-procedures-modal">
        {props?.documentTypes?.map((field: any) => (
          <Row style={{ width: "100%" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                // rules={[
                //   {
                //     required: true,
                //     message: `${field?.label} is required`,
                //   },
                // ]}
              >
                <Upload
                  id={field.id}
                  beforeUpload={() => false}
                  maxCount={1}
                  onChange={
                    props?.handleFileChange &&
                    props?.handleFileChange(field?.labelId, field?.label)
                  }
                  showUploadList={false}
                >
                  <Button
                    icon={<UploadOutlined />}
                    style={{ marginLeft: "10px", width: "100%" }}
                  >
                    SELECT FILE
                  </Button>
                </Upload>
              </Form.Item>
            </Col>

            <Col
              xs={24}
              md={24}
              sm={24}
              lg={24}
              xl={24}
              style={{ marginBottom: "0.4rem" }}
            >
              {props?.uploadedDocumentUrl &&
                props?.uploadedDocumentUrl?.length > 0 && (
                  <Table
                    showHeader={false}
                    dataSource={props?.uploadedDocumentUrl?.filter(
                      (doc) =>
                        doc?.documentLabelType === field?.label &&
                        doc?.prefilledData != true
                    )}
                    columns={[
                      {
                        title: "Document Type",
                        dataIndex: "documentLabelType",
                        key: "documentType",
                        width: "30%",
                        render: (type: string) => (
                          <Flex justify="center">
                            <Text style={{ color: "#7c8181" }}>{type}</Text>
                          </Flex>
                        ),
                      },
                      {
                        title: "Document Name",
                        dataIndex: "documentName",
                        key: "documentName",
                        width: "30%",

                        render: (name: string) => (
                          <Flex justify="center">
                            <Tooltip title={name}>
                              <Text strong style={{ color: "#7c8181" }}>
                                {name?.length > 20
                                  ? name?.substring(0, 20) + "..."
                                  : name}
                              </Text>
                            </Tooltip>
                          </Flex>
                        ),
                        // width: 520,
                      },
                      {
                        title: "Actions",
                        key: "actions",
                        width: "40%",
                        render: (_, document, i) => (
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              justifyContent: "center",
                            }}
                          >
                            {props?.isDownloadingDocument &&
                            props?.downloadingDocumentUrl ===
                              document?.documentUrl ? (
                              <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/>
                            ) : (
                              <Tooltip title="Download File">
                                <DownloadOutlined
                                  style={{
                                    color: "#273881",
                                    fontSize: "18px",
                                  }}
                                  onClick={() =>
                                    props?.handleDownloadDocument(
                                      document?.documentName,
                                      document?.documentUrl
                                    )
                                  }
                                />
                              </Tooltip>
                            )}
                            <Tooltip title="View File">
                              <EyeOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                }}
                                onClick={() => {
                                  props?.handleOpen();
                                  props?.handleSetDocumentUrl(
                                    document?.documentUrl
                                  );
                                }}
                              />
                            </Tooltip>
                            <Tooltip title="Delete File">
                              <DeleteOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                }}
                                onClick={() =>
                                  props?.handleDeleteList(
                                    document?.documentLabelType,
                                    document?.documentUrl,
                                    i
                                  )
                                }
                              />
                            </Tooltip>
                            {document?.deficiencyCheckStatus ? (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    props?.setDocumentName(
                                      document?.documentName
                                    );
                                  }
                                  if (document?.documentType) {
                                    props?.handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                                style={{ backgroundColor: "rgb(0, 109, 119)" }}
                              >
                                DEFICIENCY PASSED
                              </Button>
                            ) : document?.deficiencyCheckStatus === false ? (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    props?.setDocumentName(
                                      document?.documentName
                                    );
                                  }
                                  if (document?.documentType) {
                                    props?.handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                                danger
                              >
                                DEFICIENCY FAILED
                              </Button>
                            ) : (
                              (Array?.isArray(props?.deficiencyQuestions) ||
                                typeof props?.deficiencyQuestions ===
                                  "object") && (
                                <Button
                                  onClick={() => {
                                    if (document && document?.documentName) {
                                      props?.setDocumentName(
                                        document?.documentName
                                      );
                                    }
                                    if (document?.documentType) {
                                      props?.handleDeficiencyModal(
                                        document?.documentUrl,
                                        parseInt(document?.documentType),
                                        document
                                      );
                                    }
                                  }}
                                  type="primary"
                                  htmlType="submit"
                                >
                                  DEFICIENCY CHECK
                                </Button>
                              )
                            )}
                          </div>
                        ),
                      },
                    ]}
                    rowKey={(record) =>
                      record.documentName || `document-${record.documentUrl}`
                    }
                    pagination={false}
                    className="showUploadDoc"
                  />
                )}
            </Col>
          </Row>
        ))}
        {/* <Row justify="end" style={{ marginTop: "1rem" }}>
              <Form.Item wrapperCol={{ span: 16 }}>
                {
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      border: "1px solid darkcyan",
                      background: "darkcyan",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "white",
                    }}
                    onClick={props?.handleSubmit}
                  >
                    SUBMIT
                  </Button>
                }
              </Form.Item>
            </Row> */}
      </Form>

      {props?.activeStep !== "1" && (
        <Button
          style={{
            background: "white",
            color: "#008B8B",
            border: "1px solid #008B8B",
            boxShadow: "0px 2px 8px 0px #00000040",
            position: "absolute",
            bottom: "-2.6rem",
            zIndex: "1000",
          }}
          onClick={props?.onPrevious}
          // style={{ marginRight: 8 }}
        >
          Previous
        </Button>
      )}
    </>
  );
};

export default EnhancementCghsDocument;
